

export const tipData = {
  1: {
    0: ['词汇', '30', '10'],
    1: ['语法', '80', '30'],
    2: ['阅读', '30', '40'],
    3: ['听力', '40', '40'],
    4: ['口语', '9', '15'],
    5: ['写作', '15', '40'],
  },
  2: {
    0: ['词汇', '30', '10'],
    1: ['语法', '80', '30'],
    2: ['听力', '33', '40'],
    3: ['阅读', '18', '40'],
    4: ['写作', '10', '40'],
    5: ['口语', '22', '15'],
  },
  56: {
    0: ['单项选择', '20', '10'],
    1: ['完形填空', '20', '15'],
    2: ['阅读理解', '13', '15'],
    3: ['数学', '25', '15'],
  },
};



// WEBPACK FOOTER //
// ./src/components/testPages/welcome/constants.js